// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET_WORKSPACE } from "./action";

export function canGetWorkspace(scope: Scope): boolean {
  return scope.iamActions.includes(GET_WORKSPACE);
}
